import { Component, OnInit } from '@angular/core';
import { BreadcrumbsService } from '../../core/breadcrumbs.service';
import { Router } from '@angular/router';
import { LoginGuardService } from '../../api/login-guard.service';
import { LangService } from '../../core/lang.service';

export const attestationSteps = [
    {head: "mpt_attest_communication_head", body: "mpt_attest_communication_body", is_checked: false},
    {head: "mpt_attest_copyright_head", body: "mpt_attest_copyright_body", is_checked: false},
    {head: "mpt_attest_misconduct_header", body: "mpt_attest_misconduct_body", is_checked: false},
  ];

export const attestationStepsDuringTest = [
    {head: "mpt_attest_communication_head", body: "mpt_attest_communication_body", is_checked: false},
    {head: "mpt_attest_copyright_head", body: "mpt_attest_copyright_body_during", is_checked: false},
    {head: "mpt_attest_misconduct_header", body: "mpt_attest_misconduct_body_during", is_checked: false},
  ];
@Component({
  selector: 'attestation',
  templateUrl: './attestation.component.html',
  styleUrls: ['./attestation.component.scss']
})
export class AttestationComponent implements OnInit {

  public breadcrumb = [];
  public attestationSteps = attestationSteps;

  constructor(
    public lang:LangService,
    private loginGuard: LoginGuardService, // 
    private breadcrumbsService: BreadcrumbsService,
    private router:Router,
  ) { }

  ngOnInit() {
    this.loginGuard.deactivate();
    window.scrollTo(0,0);
    this.breadcrumb = [
      this.breadcrumbsService.APPLICANT_LANDING(),
      this.breadcrumbsService._CURRENT( this.lang.tra('title_attestation'), this.router.url),
    ];
  }
}
